import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();
const BASE = "/booking-pages";

// ── Thunks ─────────────────────────────────────────────────────────
export const fetchPages = createAsyncThunk("bookings/fetchPages",
  async () => api.get(BASE)
);

export const fetchPage = createAsyncThunk("bookings/fetchPage",
  async (id) => api.get(`${BASE}/${id}`)
);

export const createPage = createAsyncThunk("bookings/createPage",
  async (data) => api.create(BASE, data || {})
);

export const updatePage = createAsyncThunk("bookings/updatePage",
  async ({ id, data }) => api.put(`${BASE}/${id}`, data)
);

export const deletePage = createAsyncThunk("bookings/deletePage",
  async (id) => { await api.delete(`${BASE}/${id}`); return id; }
);

export const fetchBookings = createAsyncThunk("bookings/fetchBookings",
  async (id) => api.get(`${BASE}/${id}/bookings`)
);

const slice = createSlice({
  name: "bookings",
  initialState: {
    items: [],
    current: null,
    bookings: [],
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearCurrent: (s) => { s.current = null; s.bookings = []; },
  },
  extraReducers: (b) => {
    b.addCase(fetchPages.pending,    (s)    => { s.loading = true; s.error = null; })
     .addCase(fetchPages.fulfilled,  (s, a) => { s.loading = false; s.items = a.payload || []; })
     .addCase(fetchPages.rejected,   (s, a) => { s.loading = false; s.error = a.error?.message; })

     .addCase(fetchPage.pending,     (s)    => { s.loading = true; })
     .addCase(fetchPage.fulfilled,   (s, a) => { s.loading = false; s.current = a.payload; })
     .addCase(fetchPage.rejected,    (s, a) => { s.loading = false; s.error = a.error?.message; })

     .addCase(createPage.pending,    (s)    => { s.saving = true; })
     .addCase(createPage.fulfilled,  (s, a) => {
       s.saving = false;
       s.current = a.payload;
       s.items = [a.payload, ...(s.items || [])];
     })
     .addCase(createPage.rejected,   (s, a) => { s.saving = false; s.error = a.error?.message; })

     .addCase(updatePage.pending,    (s)    => { s.saving = true; })
     .addCase(updatePage.fulfilled,  (s, a) => {
       s.saving = false;
       s.current = a.payload;
       s.items = (s.items || []).map((p) => p.id === a.payload.id ? a.payload : p);
     })
     .addCase(updatePage.rejected,   (s, a) => { s.saving = false; s.error = a.error?.message; })

     .addCase(deletePage.fulfilled,  (s, a) => {
       s.items = (s.items || []).filter((p) => p.id !== a.payload);
     })

     .addCase(fetchBookings.fulfilled, (s, a) => { s.bookings = a.payload || []; });
  },
});

export const { clearCurrent } = slice.actions;
export default slice.reducer;
